import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const SimpleProgressBar = ({ background, children, color, percent }) => (
	<StyledSimpleProgressBar
		background={background}
		color={color}
		percent={percent && percent > 100 ? 100 : percent}
	>
		<span />
		{children}
	</StyledSimpleProgressBar>
)

SimpleProgressBar.propTypes = {
	background: PropTypes.string,
	children: PropTypes.any,
	color: PropTypes.string,
	percent: PropTypes.number.isRequired
}

SimpleProgressBar.defaultProps = {
	background: null,
	children: null,
	color: null
}

export const StyledSimpleProgressBar = styled.div`
	background: linear-gradient(to right, transparent, ${props => props.theme[props.background]});
	border-radius: 2px;
	position: relative;

	span {
		background: ${props => props.color ? props.theme[props.color] : props.theme.secondary};
		border-radius: 2px;
		display: block;
		height: 12px;
		width: ${props => props.percent}%;

		${props => props.percent === 100 && `
			background: ${props.theme.greenValid};
		`}
	}

	> div {
		background: transparent !important;
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;

		${props => props.percent === 100 && `
			> span {
				background: rgba(0, 0, 0, 0.5);
			}
		`}
	}
`

export default SimpleProgressBar
